/**
 * Типы и обёртка над `window.WebApp` — MAX Bridge SDK.
 * См. https://dev.max.ru/docs/webapps/bridge
 */

export interface MaxUser {
  id: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  language_code?: string;
  photo_url?: string;
}

export interface MaxChat {
  id: number;
  type: 'DIALOG' | 'CHAT' | 'CHANNEL';
}

export interface MaxInitDataUnsafe {
  user?: MaxUser;
  chat?: MaxChat;
  start_param?: string;
  query_id?: string;
  auth_date?: number;
  hash?: string;
  ip?: string;
}

export interface MaxWebApp {
  initData: string;
  initDataUnsafe: MaxInitDataUnsafe;
  platform?: string;
  version?: string;
  BackButton?: {
    show: () => void;
    hide: () => void;
    onClick: (cb: () => void) => void;
    offClick: (cb: () => void) => void;
  };
  HapticFeedback?: {
    impactOccurred: (style: 'light' | 'medium' | 'heavy') => void;
    notificationOccurred: (type: 'success' | 'warning' | 'error') => void;
  };
  requestContact?: () => Promise<{ phone: string; authDate: number; hash: string } | null>;
}

declare global {
  interface Window {
    WebApp?: MaxWebApp;
  }
}

export function getWebApp(): MaxWebApp | undefined {
  return typeof window === 'undefined' ? undefined : window.WebApp;
}
